export const RESISTRATION_FAILED_TEMPLATE = {
  MENSION1: '<@U05159V3PDZ>',
  MENSION2: '<@U05A7USV2AJ>',
  MENSION3: '<@U076WGAD4E4>',
  TEXT: 'saleceforceの登録に失敗したため架電対応お願いします',
};
